import {useMemo} from 'react';

import {apiClient} from 'common/util/api-client';
import type {FeatureFlagApiPayload, FeatureFlagApiResponse} from 'app_api/projects/feature_flags/types';

interface UseFeatureFlagsApiProps {
  projectId: number;
}

type ListFeatureFlagsResponse = FeatureFlagApiResponse[];
type GetFeatureFlagRequest = {id: string};
type CreateFeatureFlagRequest = FeatureFlagApiPayload;
type UpdateFeatureFlagRequest = FeatureFlagApiPayload & {id: string};
type DeleteFeatureFlagRequest = {id: string};

export function useFeatureFlagsApi({projectId}: UseFeatureFlagsApiProps) {
  const basePath = useMemo(() => `/api/app/projects/${projectId}/feature-flags`, [projectId]);

  function listFeatureFlags() {
    return apiClient.get<ListFeatureFlagsResponse>(basePath);
  }

  function getFeatureFlag({id}: GetFeatureFlagRequest) {
    return apiClient.get<FeatureFlagApiResponse>(`${basePath}/${id}`);
  }

  function createFeatureFlag(flag: CreateFeatureFlagRequest) {
    return apiClient.post<FeatureFlagApiResponse>(basePath, flag);
  }

  function updateFeatureFlag({id, ...flag}: UpdateFeatureFlagRequest) {
    return apiClient.put<FeatureFlagApiResponse>(`${basePath}/${id}`, flag);
  }

  function deleteFeatureFlag({id}: DeleteFeatureFlagRequest) {
    return apiClient.delete(`${basePath}/${id}`);
  }

  return {
    listFeatureFlags,
    getFeatureFlag,
    createFeatureFlag,
    updateFeatureFlag,
    deleteFeatureFlag,
  };
}
